import { useEffect, useRef, useState } from "react";

const SalesInfo = (props) => {
  const infoForm = useRef(null);

  const [filters, setFilters] = useState({
    timeline: "TODAY",
    source: "",
    assigned_role: "",
  });

  const [metrics, setMetrics] = useState({
    totalLeads: 0,
    open: 0,
    interested: 0,
    applied: 0,
  });

  // -------------------------
  // FORMAT API RESPONSE
  // -------------------------
  const formatMetrics = (apiRes) => {
    let open = 0;
    let interested = 0;
    let applied = 0;

    apiRes?.data?.forEach((row) => {
      row?.statusCounts?.forEach((s) => {
        if (s.status === "OPEN") open += s.count || 0;
        if (s.status === "INTERESTED") interested += s.count || 0;
        if (s.status === "APPLIED") applied += s.count || 0;
      });
    });
    console.log(apiRes);

    return {
      totalLeads: apiRes?.total || 0,
      open,
      interested,
      applied,
    };
  };

  // -------------------------
  // API CALL
  // -------------------------
  const getSalesInfo = (extraQuery = {}) => {
    const payload = {
      ...(filters.timeline && { timeline: filters.timeline }),
      ...(filters.source && { source: filters.source }),
      ...(filters.assigned_role && { assigned_role: filters.assigned_role }),
      ...extraQuery,
    };

    props.apis.apiGetLeadCountByStatus(payload).then((res) => {
      setMetrics(formatMetrics(res));
    });
  };

  // -------------------------
  // FILTER CHANGES
  // -------------------------
  const onTimelineChange = (value) => {
    const val = value?.[0]?.key || "TODAY";

    if (val === "CUSTOM") {
      showCustomDateFields(true);
      setMetrics({});
    } else {
      showCustomDateFields(false);
      setFilters((p) => ({ ...p, timeline: val }));
    }
  };

  const onSourceChange = (value) => {
    setFilters((p) => ({
      ...p,
      source: value?.[0]?.key || "",
    }));
  };

  const onRoleChange = (value) => {
    setFilters((p) => ({
      ...p,
      assigned_role: value?.[0]?.key || "",
    }));
  };

  // -------------------------
  // CUSTOM DATE SEARCH
  // -------------------------
  const onSearch = () => {
    const formData = infoForm.current.form.current.getData();

    getSalesInfo({
      timeline: "CUSTOM",
      startDate: new Date(formData.startDate).toISOString().split("T")[0],
      endDate: new Date(formData.endDate).toISOString().split("T")[0],
    });
  };

  const onReset = () => {
    infoForm.current.form.current.reset();
    showCustomDateFields(false);
    setFilters((p) => ({ ...p, timeline: "TODAY" }));
  };

  // -------------------------
  // SHOW/HIDE Custom Date Inputs
  // -------------------------
  const showCustomDateFields = (show = false) => {
    const ids = [
      "leadinfo-column-startDate",
      "leadinfo-column-endDate",
      "leadinfo-column-search_btn",
      // "leadinfo-column-reset_btn",
    ];
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) show ? el.classList.remove("d-none") : el.classList.add("d-none");
    });
  };

  // -------------------------
  // EFFECT: Fetch when filters change
  // -------------------------
  useEffect(() => {
    getSalesInfo();
  }, [filters.timeline, filters.source, filters.assigned_role]);

  // -------------------------
  // UI Card Data
  // -------------------------
  const cardData = [
    {
      title: "Total Leads",
      icon: imagepaths.peopleIcon,
      count: metrics.totalLeads,
      amount: metrics.totalLeads,
    },
    {
      title: "Open Leads",
      icon: imagepaths.multiSearchIcon,
      count: metrics.open,
      amount: metrics.open,
    },
    {
      title: "Interested Leads",
      icon: imagepaths.peopleGroupIcon,
      count: metrics.interested,
      amount: metrics.interested,
    },
    {
      title: "Applied Leads",
      icon: imagepaths.starBarIcon,
      count: metrics.applied,
      amount: metrics.applied,
    },
  ];

  props.$setNode({ props, metrics });

  return (
    <div className="mb-4 dashboard_form_box">
      <h2 className="fs-4 mt-2 float-left">Sales Info.</h2>

      <div className="form_outer">
        <AppForm
          ref={infoForm}
          onSubmit={onSearch}
          className="row justify-content-end"
        >
          {/* Assigned Role */}
          <div className="col-12 col-md-4 col-lg-4 col-xxl-3 col-xl-2">
            <AppInputFocus
              type="select"
              name="assigned_role"
              label="Role"
              options={_enum.ASSIGNED_ROLES}
              onChange={onRoleChange}
              placeholder="Role"
            />
          </div>

          {/* Source */}
          <div className="col-12 col-md-4 col-lg-4 col-xxl-3 col-xl-2">
            <AppInputFocus
              type="select"
              name="source"
              label="Source"
              options={_enum.SOURCE_FILTERS}
              onChange={onSourceChange}
              placeholder="Source"
            />
          </div>

          {/* Timeline */}
          <div className="col-12 col-md-4 col-lg-4 col-xxl-3 col-xl-2">
            <AppInputFocus
              type="select"
              name="timeline"
              label="Time Line"
              options={_enum.OVERALL_DETAIL}
              onChange={onTimelineChange}
              defaultValue="TODAY"
              placeholder="Time Line"
            />
          </div>

          {/* CUSTOM DATES */}
          <div
            className="col-12 col-md-4 col-lg-4 col-xxl-3 col-xl-2 d-none"
            id="leadinfo-column-startDate"
          >
            <AppInputFocus
              type="date"
              name="startDate"
              label="Start Date"
              required
            />
          </div>

          <div
            className="col-12 col-md-4 col-lg-4 col-xxl-3 col-xl-2 d-none"
            id="leadinfo-column-endDate"
          >
            <AppInputFocus
              type="date"
              name="endDate"
              label="End Date"
              required
            />
          </div>

          <div
            className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
            id="leadinfo-column-search_btn"
          >
            <button type="submit" className="btn btn-primary search_btn">
              <i className="fa fa-search"></i>
              <span>Search</span>
            </button>
          </div>

          <div
            className="col-2 col-md-1 col-lg-1 col-xl-1"
            id="leadinfo-column-reset_btn"
          >
            <button
              type="button"
              className="btn btn-primary search_btn"
              onClick={onReset}
            >
              <i className="fa-solid fa-filter-circle-xmark"></i>
              <span>Reset</span>
            </button>
          </div>
        </AppForm>
      </div>

      <div className="row pt-0">
        {cardData.map((card, index) => (
          <div className="col-xl-3 col-sm-6" key={index}>
            <div className="card dashboard_card application_card revenue_info_card">
              <div className="card-body justify-content-start">
                <div className="icon_container me-3">
                  <div className="icon bg-transparent">
                    <img
                      src={card?.icon}
                      className="w-100 h-auto"
                      alt="icon image"
                    />
                  </div>
                </div>
                <div className="content">
                  <p className="card_label">{card.title}</p>
                  <p className="count">{card.count}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default constore(SalesInfo);
